const isStringValue = (option) => typeof option === 'string';
export const getSelectedOption = (selectedOption, options) => {
    var _a;
    if (!selectedOption) {
        return null;
    }
    if (options && options.length > 0) {
        if (Array.isArray(selectedOption)) {
            if (selectedOption.every(isStringValue)) {
                return options.filter((option) => selectedOption.includes(option.value));
            }
        }
        else {
            if (isStringValue(selectedOption)) {
                return (_a = options.find((option) => option.value === selectedOption)) !== null && _a !== void 0 ? _a : null;
            }
        }
    }
    return selectedOption;
};
export const getLabelForSelectedOption = (option, formatFunc) => {
    if (!option || (Array.isArray(option) && option.length === 0)) {
        return null;
    }
    if (typeof formatFunc === 'function') {
        return formatFunc(option);
    }
    if (typeof option === 'string') {
        return option;
    }
    return Array.isArray(option)
        ? option.map((entry) => (isStringValue(entry) ? entry : entry.label)).join(', ')
        : option.label;
};
